import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/channel/take-play.png';
import _imports_1 from '@/assets/componentImg/channel/like.png';

const _withScopeId = n => (_pushScopeId("data-v-0f130fc0"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "play-icon",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "user-wrap"
};
const _hoisted_4 = {
  class: "like-count"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

import composition from '@/composition';
export default {
  props: {
    item: Object
  },

  setup(__props) {
    const props = __props;
    const {
      ref,
      openWebPage,
      CImage
    } = composition();
    const coverImg = ref({});

    if (props.item.images && props.item.images.length > 0) {
      const images = [...props.item.images];
      coverImg.value = images[0];
    } else if (props.item.videos && props.item.videos.length > 0) {
      const images = [...props.item.videos];
      coverImg.value = images[0];
    }

    const openDetail = () => {
      openWebPage('moment.html', props.item.id);
    };

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock("div", {
        class: "cell",
        onClick: openDetail
      }, [__props.item.images.length > 0 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        class: _normalizeClass(['content-img', coverImg.value.width > coverImg.value.height ? 'width-content-img' : '']),
        src: coverImg.value.filePath,
        fit: "cover"
      }, null, 8, ["class", "src"])) : __props.item.videos.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_van_image, {
        class: _normalizeClass(['content-img', coverImg.value.width > coverImg.value.height ? 'width-content-img' : '']),
        src: coverImg.value.coverPath,
        fit: "cover"
      }, null, 8, ["class", "src"]), _hoisted_1], 64)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_2, _toDisplayString(__props.item.content), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(CImage), {
        class: "head-img",
        src: __props.item.memberPhoto
      }, null, 8, ["src"]), _createElementVNode("p", null, _toDisplayString(__props.item.memberNickname), 1), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createTextVNode(" " + _toDisplayString(__props.item.loveCount), 1)])])]);
    };
  }

};